import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

export default function Layout({ children, setPage, onLogout }) {
  return (
    <div>
      <Header onLogout={onLogout} />

      <div className="d-flex">
        <Sidebar setPage={setPage} />

        <div className="p-4 w-100">{children}</div>
      </div>
    </div>
  );
}